// Типы полей которые доступны в форме посроения документа
export const DOCUMENT_AVAILABLE_FIELDS = {
  text: "string",
  integer: "integer",
  textarea: "text",
  datePicker: "date",
  file: "file",
  dicom: "dicom",
  params: "params",
  paramnorms: "paramnorms",
  source: "source",
  patientDisease: "patientdisease",
  param: "param",
  bool: "bool",
  radio: "radio",
  select: "select",
};
